import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import RoomTypeService from "../../services/roomtype.services";

/* =================== Thunks =================== */

export const getroomType = createAsyncThunk(
  "roomType/getroomType",
  async (params, thunkAPI) => {
    try {
      const response = await RoomTypeService.getroomType(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addroomType = createAsyncThunk(
  "roomType/addroomType",
  async (data, thunkAPI) => {
    try {
      const response = await RoomTypeService.addroomType(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateroomType = createAsyncThunk(
  "roomType/updateroomType",
  async (payload, thunkAPI) => {
    try {
      const response = await RoomTypeService.editroomType(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteroomType = createAsyncThunk(
  "roomType/deleteroomType",
  async (id, thunkAPI) => {
    try {
      await RoomTypeService.deleteroomType(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  roomTypeList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const roomTypeSlice = createSlice({
  name: "roomType",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getroomType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getroomType.fulfilled, (state, action) => {
        state.loading = false;
        state.roomTypeList = action.payload?.rooms || [];
      })
      .addCase(getroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addroomType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addroomType.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.roomTypeData ||
          action.payload;

        if (newHotel) {
          state.roomTypeList.unshift(newHotel);
        }
      })
      .addCase(addroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateroomType.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateroomType.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.roomTypeData;

        if (updated?._id) {
          const index = state.roomTypeList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.roomTypeList[index] = updated;
          }
        }
      })
      .addCase(updateroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteroomType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteroomType.fulfilled, (state, action) => {
        state.loading = false;
        state.roomTypeList = state.roomTypeList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = roomTypeSlice.actions;
export default roomTypeSlice.reducer;
